import styled from 'styled-components';
import {
  appHeaderColor,
  whiteColor,
  mediumFont,
  screenSize,
} from '@app/styles';
import HeaderLogoUrl from '@app/assets/images/TransferStampLogo.svg';

export const BackgroundContainer = styled.div`
  background-color: ${appHeaderColor};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 65px;
  padding-left: 15px;
  color: ${whiteColor};
  @media (${screenSize.tablet}) {
    height: 55px;
    padding: 0 15px;
    margin: 0 20px 0 20px;
  }
`;
export const Actions = styled.div`
  ${mediumFont};
  @media (${screenSize.tablet}) {
    font-size: 16px;
  }
  @media (${screenSize.maxMobile}) {
    position: absolute;
    right: 15px;
  }
`;
export const HeaderLogo = styled.div`
  height: 32px;
  width: 151px;
  opacity: 1;
  background-image: url(${HeaderLogoUrl});
  background-position: 0 center;
  background-repeat: no-repeat;
  cursor: pointer;
`;
